import {
  THANKYOUPAGE_URL_PARAMS,
  THANKYOUPAGE_INFO,
  UPDATE_BOOKING_STATUS,
  SET_THANKYOU_ERROR,
  SET_FEEDBACK_STATUS
    } from './constants';
  import {
    ITHANKYOUPAGE_URL_PARAMS,
   
    } from './Validation';
//   export function toggleReviewDataLoading(
//     actionData: ITOGGLE_REVIEW_DATA_LOADING['actionData'],
//   ): ITOGGLE_REVIEW_DATA_LOADING {
//     return {
//       type: TOGGLE_REVIEW_DATA_LOADING,
//       actionData,
//     };
//   }
  
//   export function updateTentativeAction(
//     actionData: IUPDATE_TENTATIVE_ACTION['actionData'],
//   ): IUPDATE_TENTATIVE_ACTION {
//     return {
//       type: UPDATE_TENTATIVE_ACTION,
//       actionData,
//     };
//   }
  
//   export function setGoSafeData(actionData:any){
//     return {
//       type:SET_GO_SAFE_DATA,
//       actionData
//     }
//   }
//   export function setGoSafeSocialData(actionData:any){
//     return {
//       type:SET_GO_SAFE_SOCIAL_DATA,
//       actionData
//     }
//   }
//   export function setDepotReviewAPI(actionData:any){
//     return {
//       type:SET_DEPOT_REVIEW_API,
//       actionData
//     }
//   }
//   export function setSelectedPromoCode (actionData:any){
//     return {
//       type: SET_SELECTED_PROMO_CODE,
//       actionData
//     }
//   }
//   export function toggleGoCashSelection (actionData:any){
//     return {
//       type: TOGGLE_GOCASH_SELECTION,
//       actionData
//     }
//   }
export function updateThankyouPageURLParams(actionData:ITHANKYOUPAGE_URL_PARAMS['actionData']):ITHANKYOUPAGE_URL_PARAMS{
  return {
    type: THANKYOUPAGE_URL_PARAMS,
    actionData
  }
}
export function updateThankyouPageInfo(actionData){
 
  return {
    type: THANKYOUPAGE_INFO,
    actionData
  }
}
export function updateBookingStatus(actionData){
  return {
    type:UPDATE_BOOKING_STATUS,
    actionData
  }
}
export function setThankyouPageError(actionData){
  return {
    type:SET_THANKYOU_ERROR,
    actionData
  }
}
export function setFeedBackStatus(actionData){
  return {
    type:SET_FEEDBACK_STATUS,
    actionData
  }
}
